module.exports = __webpack_public_path__ + "media/images/top/top_pickup_company_08-a99eece407ba4c97955face7db89cd50.png";